<template>
  <div class="base-container">
    <ArawerCard />
    <div
      v-if="infoList.isIframe == '0' && LoginType && ciphertext && cipUsername"
      class="yhzximg"
      @click="openDraw = UserConsulShow = true"
      @mouseenter="isHovered2 = true"
      @mouseleave="isHovered2 = false"
    >
      <div class="icon-container" @click="handleuserinfo">
        <img :src="isHovered2 ? hdb01 : hdb02" alt="" />
      </div>
      <div class="text-container" @click="handleuserinfo">获取信息</div>
      <div class="getuserdraw" v-if="userType">
        <div class="userlist">
          <div class="icon-wrapper">
            <img :src="user02" alt="用户名图标" />
          </div>
          <div class="text-wrapper2" @click="copyUsername">获取用户名</div>
        </div>
        <div class="userlist2">
          <div class="icon-wrapper">
            <img :src="user01" alt="密码图标" />
          </div>
          <div class="text-wrapper2" @click="copyPassword">获取用户密码</div>
        </div>
      </div>
    </div>
    <AppNewHeader :userName="userName" :placeholderText="'请输入数据库名称'" />
    <div class="promotion">
      <div class="promotionList">
        <el-breadcrumb separator="|">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/knowledge' }"
            >知识库产品</el-breadcrumb-item
          >
          <el-breadcrumb-item>{{ infoList.title }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    <div class="content-wrapper" v-loading="loading">
      <div class="main-content">
        <!-- 左侧内容区域 -->
        <div class="left-section">
          <!-- 标题和主要内容 -->
          <div class="content_div">
            <p class="content_title">{{ infoList.title }}</p>
            <div class="content_fx">
              <div class="content_fx_icon">
                <p>分享到：</p>
                <img
                  @click="shareTo('qq')"
                  class="qq_fx"
                  :src="qq_fx"
                  alt="QQ分享"
                />
                <img
                  @click="shareTo('weibo')"
                  class="wb_fx"
                  :src="wb_fx"
                  alt="微博分享"
                />
                <img
                  @click="shareTo('wechat')"
                  class="wx_fx"
                  :src="wx_fx"
                  alt="微信分享"
                />
              </div>
              <div
                class="qr_draw"
                @click="closeQrModal"
                v-if="showWechatQr"
              ></div>
              <div
                v-if="showWechatQr"
                class="qr-code-modal"
                @click="closeQrModal"
              >
                <div class="qr-code-container" @click.stop>
                  <!-- <div class="qr-code-title">微信分享</div> -->
                  <img
                    :src="qrCodeUrl"
                    alt="微信分享二维码"
                    class="qr-code-image"
                  />
                  <p class="qr-code-tip">扫描二维码分享到微信</p>
                </div>
              </div>
            </div>
            <div class="content_row" v-if="infoList.description">
              <span class="content_row_tit"
                >简&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;介：</span
              >
              <p class="content_row_right" v-html="infoList.description"></p>
            </div>
            <div class="content_row" v-if="infoList.netVersion == 1||infoList.mirrorVersion == 1">
              <span class="content_row_tit">访问方式：</span>
              <p class="content_row_right">
                <span v-if="infoList.netVersion == 1">网络访问</span>
                <span
                  v-if="infoList.mirrorVersion == 1 && infoList.netVersion == 1"
                >
                  |
                </span>
                <span v-if="infoList.mirrorVersion == 1">镜像访问</span>
              </p>
            </div>
            <div class="content_row">
              <span class="content_row_tit">适用用户：</span>
              <p class="content_row_right">{{ getSyyh(infoList.bussinessCid) }}</p>
            </div>
            <div class="content_row">
              <span class="content_row_tit">销售区域：</span>
              <p class="content_row_right">
                {{ infoList.saleArea ? infoList.saleArea : "全国" }}
              </p>
            </div>
            <div class="content_row">
              <span class="content_row_tit">销售行业：</span>
              <p class="content_row_right">
                {{ infoList.saleIndustry ? infoList.saleIndustry : "全行业" }}
              </p>
            </div>
            <div class="content_row">
              <span class="content_row_tit">资源总量：</span>
              <p class="content_row_right">
                {{ infoList.dataCount == 0 ? "暂无统计" : infoList.dataCount }}
              </p>
            </div>
            <div class="content_row">
              <span class="content_row_tit">访&nbsp;问&nbsp;量：</span>
              <p class="content_row_right">
                {{ infoList.useCount == 0 ? "暂无统计" : infoList.useCount }}
              </p>
            </div>
            <div class="action-buttons">
              <div class="btn" @click="triggerParentEvent($event)">
                <img
                  style="width: 16px; height: 16px"
                  :src="imge0"
                  alt=""
                /><span style="margin-left: 5px">加入采购清单</span>
              </div>
              <!-- <div class="btn1" @click="redirectToWeb(infoList)">申请试用</div> -->
              <div
                v-show="infoList.webUrl"
                class="btn1"
                @click="openIfraem(infoList)"
              >
                知识库预览
              </div>
              <!-- <div
                class="btn1"
                v-if="LoginType && infoList.webUrl"
                @click="openuser(infoList)"
              >
                直接使用
              </div> -->
            </div>
          </div>
          <div>
            <div class="tab_div">
              <div
                class="tab_div_div"
                @click="changeTab(1)"
                :class="tabIndex == 1 ? 'tabActive' : ''"
              >
                <p>图片展示</p>
              </div>
              <div
                class="tab_div_div tab_div_div2"
                @click="changeTab(2)"
                :class="tabIndex == 2 ? 'tabActive' : ''"
                v-if="infoList.feature"
              >
                <p>特色亮点</p>
              </div>
              <div
                class="tab_div_div"
                @click="changeTab(3)"
                :class="tabIndex == 3 ? 'tabActive' : ''"
                v-if="infoList.attaches && infoList.attaches.length > 0"
              >
                <p>资料下载</p>
              </div>
            </div>
            <div class="tab_content_div">
              <div v-if="tabIndex == 1">
                <div
                  class="info-banner"
                  v-if="infoList.images && infoList.images.length > 0"
                >
                  <el-carousel indicator-position="outside" height="491.77px">
                    <el-carousel-item
                      v-for="(item, index) in infoList.images"
                      :key="index"
                    >
                      <img
                        :src="getImagePath(item.filePath)"
                        alt=""
                        style="width: 100%; height: 100%; object-fit: cover"
                      />
                    </el-carousel-item>
                  </el-carousel>
                </div>
              </div>
              <div v-if="tabIndex == 2">
                <div
                  style="padding: 20px"
                  v-html="infoList.feature"
                  class="feature_div"
                ></div>
              </div>
              <div v-if="tabIndex == 3">
                <div style="padding: 20px" class="attach_div">
                  <ul class="attach_ul">
                    <li v-for="(attach, index) in infoList.attaches">
                      <p>{{ index + 1 }}.{{ attach.title }}</p>
                      <p
                        class="attach_down"
                        @click="downloadAttach(attach.filePath, attach.title)"
                      >
                        下载
                      </p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <!-- 信息卡片 -->
          <!-- <div class="info-cards">
            <div class="info-card" v-if="infoList.contentFrom">
              <h3 class="card-title">数据库特色亮点</h3>
              <p class="card-content">
                {{ infoList.contentFrom }}
              </p>
              <div
                class="info-banner"
                :style="
                  infoList.contentFrom
                    ? { width: '994px' }
                    : { width: 'auto', height: '525.85px' }
                "
                v-if="infoList.images && infoList.images.length > 0"
              >
                <el-carousel indicator-position="outside" height="525.85px">
                  <el-carousel-item
                    v-for="(item, index) in infoList.images"
                    :key="index"
                  >
                    <img
                      :src="getImagePath(item.filePath)"
                      alt=""
                      style="width: 100%; height: 100%; object-fit: cover"
                    />
                  </el-carousel-item>
                </el-carousel>
              </div>
            </div>
            <div class="info-card" v-if="infoList.dataFunction">
              <h3 class="card-title">数据功能</h3>
              <p class="card-content"></p>
            </div>
          </div> -->

          <!-- <div v-if="!infoList.contentFrom">
            <div
              class="info-banner"
              v-if="infoList.images && infoList.images.length > 0"
            >
              <el-carousel indicator-position="outside" height="525.85px">
                <el-carousel-item
                  v-for="(item, index) in infoList.images"
                  :key="index"
                >
                  <img
                    :src="getImagePath(item.filePath)"
                    alt=""
                    style="width: 100%; height: 100%; object-fit: cover"
                  />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div> -->
        </div>

        <!-- 右侧榜单 -->
        <div>
          <div class="right-section">
            <div class="ranking-div">
              <h3 class="ranking-title">相关知识库推荐</h3>
            </div>

            <div class="ranking-list">
              <div
                class="ranking-item"
                v-for="(item, index) in knowLaDeist"
                :key="index"
                @mouseenter="hoverIndex = index"
                @mouseleave="hoverIndex = -1"
                :class="{ 'item-hover': hoverIndex === index }"
                v-show="index < 10"
                @click="datainfo(item.id)"
              >
                <div
                  class="rank-badge"
                  :class="`rank-${index + 1}`"
                  v-if="index >= 3"
                >
                  {{ index + 1 }}
                </div>
                <div
                  class="rank-badge"
                  :class="`rank-${index + 1}`"
                  v-else
                ></div>
                <img
                  :src="getImagePath(item.imgUrl)"
                  class="right_img"
                  v-if="item.imgUrl"
                />
                <div class="right_content_title">
                  <div class="rank-name" :title="item.title">
                    {{ item.title }}
                  </div>
                  <p
                    class="content_row_right right_fangshi"
                    style="font-size: 12px; color: #999999"
                  >
                    <img
                      :src="wlfw"
                      alt=""
                      style="width: 12px; height: 12px; margin-right: 4px"
                    />
                    <span v-if="item.netVersion == 1">网络访问</span>
                    <span
                      v-if="item.mirrorVersion == 1 && item.netVersion == 1"
                    >
                      |
                    </span>
                    <span v-if="item.mirrorVersion == 1">镜像访问</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="right-section right-section1">
            <div class="ranking-div ranking-div1">
              <h3 class="ranking-title ranking-title1">知识库榜单</h3>
            </div>

            <div class="ranking-list" v-loading="loading1">
              <div
                class="ranking-item"
                v-for="(item, index) in knowledgeSaleList"
                :key="index"
                @mouseenter="hoverIndex = index"
                @mouseleave="hoverIndex = -1"
                :class="{ 'item-hover': hoverIndex === index }"
                v-show="index < 10"
                @click="datainfo(item.id)"
              >
                <div
                  class="rank-badge"
                  :class="`rank-${index + 1}`"
                  v-if="index >= 3"
                >
                  {{ index + 1 }}
                </div>
                <div
                  class="rank-badge"
                  :class="`rank1-${index + 1}`"
                  v-else
                ></div>
                <img
                  :src="getImagePath(item.imgUrl)"
                  class="right_img"
                  v-if="item.imgUrl"
                />
                <div class="right_content_title">
                  <div class="rank-name" :title="item.title">
                    {{ item.title }}
                  </div>
                  <p
                    class="content_row_right right_fangshi"
                    style="font-size: 12px; color: #999999"
                  >
                    <img
                      :src="wlfw"
                      alt=""
                      style="width: 12px; height: 12px; margin-right: 4px"
                    />
                    <span v-if="item.netVersion == 1">网络访问</span>
                    <span
                      v-if="item.mirrorVersion == 1 && item.netVersion == 1"
                    >
                      |
                    </span>
                    <span v-if="item.mirrorVersion == 1">镜像访问</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      v-model="centerDialogVisible"
      :title="baidutitle"
      width="1200px"
      center
      @close="handleDialogClose"
      class="el-dialog--center"
    >
      <!-- Loading overlay -->
      <div v-if="iframeLoading" class="iframe-loading-overlay">
        <div class="loading-content">
          <p class="closebut" @click="closeLoading">关闭</p>
          <el-progress
            type="circle"
            :percentage="iframeProgress"
            :status="iframeStatus"
          />
          <p class="loading-text">正在加载中，请稍候...</p>
        </div>
      </div>

      <iframe
        ref="baiduIframe"
        :src="baiduUrl"
        frameborder="0"
        class="baidu-iframe"
        allowfullscreen
        @load="onIframeLoad"
        @error="onIframeError"
        :style="{ visibility: iframeLoading ? 'hidden' : 'visible' }"
      ></iframe>
    </el-dialog>
    <el-footer>
      <div>
        <AppFooter></AppFooter>
      </div>
    </el-footer>
  </div>
</template>

<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import { ArrowRight } from "@element-plus/icons-vue";
import AppNewHeader from "@/views/components/AppNewHeader.vue";
import AppFooter from "@/views/components/AppFooter.vue";
import {
  PostKonwInfo,
  PostknowLaDeist,
  getUnitUser,
  getBuyLog,
  getBuyKnowledgeBaseList,
} from "@/api/index.js";
import wlfw from "@/assets/newimages/wlfw.png";
import imge0 from "@/assets/headerimage/card002.png";
import qq_fx from "@/assets/newimages/qq_fx.png";
import wb_fx from "@/assets/newimages/wb_fx.png";
import wx_fx from "@/assets/newimages/wx_fx.png";
import { useRoute, useRouter } from "vue-router";
import ArawerCard from "@/views/components/ArawerCard.vue";
import hdb02 from "@/assets/image/getuser01.png";
import hdb01 from "@/assets/image/getuser02.png";
import user01 from "@/assets/image/usericon.png";
import user02 from "@/assets/image/usericon02.png";
import { usePageStayTime } from "@/utils/usePageStayTime";
const { stayTime, totalStayTimes } = usePageStayTime();
import bus from "@/mitt/bus.js";
import CryptoJS from "crypto-js";
import { Cookie } from "@/utils/Cookie";
const SECRET_KEY = "hjkfhjkahjkuifeu1234414b";
const ECB_KEY = CryptoJS.enc.Utf8.parse(SECRET_KEY);
import { ElMessage } from "element-plus"; // 或其他UI库的消息提示
const rankingData = ref([
  { rank: 1, name: "“长江云阅读”数字化全民阅读服务平台”" },
  { rank: 2, name: "学术文献数据库平台" },
  { rank: 3, name: "丝路物语专题库关学文库" },
  { rank: 4, name: "知识服务平台纸上长安系列图书专题数据库" },
  { rank: 5, name: "汉调恍恍资源管理平台" },
  { rank: 6, name: "中国传统戏曲文化资源库" },
  { rank: 7, name: "西安秦腔剧本精编" },
  { rank: 8, name: "筑牢中华民族共同体意识数据库" },
  { rank: 9, name: "延安时期红色档案数据库" },
  { rank: 10, name: "航空工业知识服务平台" },
]);
const iframeLoading = ref(true);
const iframeProgress = ref(0);
const iframeStatus = ref(null);
const iframeProgressInterval = ref(null);
const ciphertext = ref("");
const cipUsername = ref("");
const isHovered2 = ref(false);
const userType = ref(false);
const centerDialogVisible = ref(false);
const route = useRoute();
const router = useRouter();
const baiduUrl = ref("http://yahsda.com/");
const baidutitle = ref("");
const infoList = ref([]);
const knowLaDeist = ref([]);
const knowledgeSaleList = ref([]);
const lableBtnRef = ref(null);
const loading = ref(false);
const loading1 = ref(false);
const LoginType = ref(false);
const weburl = ref(window.location.href);
const userString = JSON.parse(Cookie.get("userInfo")) || null;
const tabIndex = ref(1);
import QRCode from "qrcode";

const currentUrl = ref(window.location.href);
const pageTitle = ref(document.title);
const showWechatQr = ref(false);
const qrCodeUrl = ref("");
// 生成二维码
const generateQrCode = async () => {
  try {
    qrCodeUrl.value = await QRCode.toDataURL(currentUrl.value, {
      width: 200,
      margin: 2,
    });
  } catch (err) {
    console.error("生成二维码失败:", err);
    // 备用方案：使用第三方API生成二维码
    qrCodeUrl.value = `https://api.qrserver.com/v1/create-qr-code/?size=200x200&data=${encodeURIComponent(
      currentUrl.value
    )}`;
  }
};

// 微信分享
const shareToWechat = () => {
  // 先尝试使用微信JS-SDK
  if (typeof wx !== "undefined") {
    wx.updateAppMessageShareData({
      title: pageTitle.value,
      desc: "分享描述",
      link: currentUrl.value,
      imgUrl: "分享图标URL",
    });
  } else {
    // 显示二维码弹窗
    showWechatQr.value = true;
    generateQrCode();
  }
};

// 关闭二维码弹窗
const closeQrModal = () => {
  showWechatQr.value = false;
};

// 分享功能路由
const shareTo = (platform) => {
  const shareUrl = encodeURIComponent(currentUrl.value);
  const shareTitle = encodeURIComponent(pageTitle.value);

  switch (platform) {
    case "qq":
      shareToQQ(shareUrl, shareTitle);
      break;
    case "weibo":
      shareToWeibo(shareUrl, shareTitle);
      break;
    case "wechat":
      shareToWechat();
      break;
  }
};

const shareToQQ = (url, title, summary = "", pic = "") => {
  const shareUrl =
    `https://connect.qq.com/widget/shareqq/index.html?` +
    `url=${encodeURIComponent(url)}&` +
    `title=${encodeURIComponent(title)}&` +
    `desc=${encodeURIComponent(summary || title)}&` +
    `pics=${encodeURIComponent(pic || "")}`;

  window.open(shareUrl, "_blank", "width=615,height=505");
};
// 微博分享
const shareToWeibo = (url, title) => {
  window.open(
    `https://service.weibo.com/share/share.php?url=${currentUrl.value}&title=${title}`
  );
};
const changeTab = (val) => {
  tabIndex.value = val;
};

// const downloadAttach = (filePath, title) => {
//   var href =
//     location.origin +
//     "/ckbop/file/download?title=" +
//     title.substring(0, title.indexOf(".")) +
//     "&fileCode=" +
//     filePath;
//   window.open(href, "_blank");
// };
const downloadAttach = (filePath, title) => {
  // var href = 'http://116.204.32.234:8070/ckbop/file/download?title='+title.substring(0,title.indexOf('.'))+"&fileCode="+filePath;
  var href =
    location.origin +
    "/ckbop/front/resource/download?title=" +
    title.substring(0, title.indexOf(".")) +
    "&fileCode=" +
    filePath;
  // // window.open(href,"_blank");
  // // 获取文件名及扩展名
  //   const fileName = title.substring(0,title.indexOf('.')) // 获取文件名，默认设置为 '导出' 如果无法解析
  //   let link = document.createElement('a')
  //   link.style.display = 'none'
  //   link.href = href

  //   // 设置 download 属性为文件名（包含扩展名）
  //   link.setAttribute('download', title)

  //   // 将链接添加到页面并触发点击事件
  //   document.body.appendChild(link)
  //   link.click()

  //   // 点击完成后，移除链接
  //   document.body.removeChild(link)
  const purl = href; // '/upload/202210/2022101909281894e43d.png'
  console.log(purl);
  const x = new window.XMLHttpRequest();
  x.open("GET", purl, true);
  x.responseType = "blob";
  x.onload = () => {
    const url = window.URL.createObjectURL(x.response);
    const a = document.createElement("a");
    a.href = url;
    a.download = title; // 2. 重命名文件
    a.click();
  };
  // console.log(path, title);
  x.send();
};
const user = userString || null;
if (user && user.userType === "manage") {
  LoginType.value = true;
} else if (user && user.userType === "normal") {
  LoginType.value = false;
}

const getSyyh = (businessCid)=>{
  var syyh = [];
  if(businessCid){
    if(businessCid.indexOf('396')>-1){
      syyh.push("政府部门");
    }
    if(businessCid.indexOf('397')>-1){
      syyh.push("科研机构");
    }
    if(businessCid.indexOf('398')>-1){
      syyh.push("公共图书馆");
    }
    if(businessCid.indexOf('399')>-1){
      syyh.push("高校图书馆");
    }
  }
  else{
    syyh = ["公共图书馆","高校图书馆"]
  }
  return syyh.join('、')
}

const userName = ref("");
const checkTokenStatus = async () => {
  const token = JSON.parse(Cookie.get("token")) || "";
  if (token && !isTokenExpired(token)) {
    const userString = JSON.parse(Cookie.get("userInfo")) || null;
    const user = userString || null;
        userName.value = user?.realName;;
  }
};

const isTokenExpired = (token) => {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    if (payload.exp) {
      return Date.now() >= payload.exp * 1000;
    }
    return false; // 如果没有exp字段，则认为永不过期
  } catch (e) {
    return true; // 解析失败视为过期
  }
};
const handleLog = async () => {
  try {
    const res = await getBuyLog({
      type: "3",
      url: weburl.value,
      text: infoList.value.title,
      second: stayTime._value,
    });
    if (res) {
    }
  } catch (error) {
    console.log(error);
  }
};
onMounted(async () => {
  await checkTokenStatus();
  await getKnowledgeSaleList();
  const id = route.query.id;
  if (id) {
    await handleKonwInfo(id);
  }
});

const handlecloseloding = () => {
  iframeLoading.value = false;
};

const handleDialogClose = () => {
  resetIframeState();
};

const closeLoading = () => {
  iframeLoading.value = false;
  stopIframeLoading();
};
const openIfraem = (dataUrl) => {
  if (dataUrl.isIframe == "0") {
    window.open(dataUrl.webUrl, "_blank");
  } else {
    if (dataUrl.webUrl) {
      // 构建完整的路由URL
      const routeUrl = router.resolve({
        name: "iframesy",
        query: {
          name: dataUrl.webUrl,
          knowledgeId: dataUrl.id,
          isIfream: dataUrl.isIframe,
          istype: "1",
        },
      }).href;

      // 在新窗口打开
      window.open(routeUrl, "_blank");
    } else {
      ElMessage.warning("暂无试用，请联系销售人员");
    }
  }
};

const openuser = (item) => {
  if (item.isIframe == "0") {
    window.open(item.webUrl, "_blank");
  } else {
    if (item.webUrl) {
      router.push({
        name: "iframesy",
        query: {
          name: item.webUrl,
          knowledgeId: item.id,
          isIfream: item.isIframe,
          istype: "0",
        },
      });
    } else {
      ElMessage.warning("暂无试用，请联系销售人员");
    }
  }
};

const resetIframeState = () => {
  stopIframeLoading();
  iframeLoading.value = false;
  iframeProgress.value = 0;
  iframeStatus.value = null;
  // Clear the iframe src to prevent caching issues
  if (baiduUrl.value) {
    baiduUrl.value = "";
  }
};
const startIframeLoading = () => {
  iframeLoading.value = true;
  iframeProgress.value = 0;
  iframeStatus.value = null;

  iframeProgressInterval.value = setInterval(() => {
    if (iframeProgress.value < 90) {
      iframeProgress.value += 10;
    }
  }, 100);
};

const stopIframeLoading = () => {
  if (iframeProgressInterval.value) {
    clearInterval(iframeProgressInterval.value);
    iframeProgressInterval.value = null;
  }
};

const onIframeError = () => {
  iframeStatus.value = "exception";
  setTimeout(() => {
    iframeLoading.value = false;
    stopIframeLoading();
  }, 500);
};

const onIframeLoad = () => {
  iframeProgress.value = 100;
  iframeStatus.value = "success";

  setTimeout(() => {
    iframeLoading.value = false;
    stopIframeLoading();
  }, 500);
};
const handleDrawerClose = () => {
  const overlayDialog = document.querySelector(".el-overlay-dialog");
  if (overlayDialog) {
    overlayDialog.style.overflow = "auto";
  }
};
onUnmounted(async () => {
  const overlayDialog = document.querySelector(".el-overlay-dialog");
  if (overlayDialog) {
    overlayDialog.style.overflow = "auto";
  }
  await handleLog();

  stopIframeLoading();
  removeEventHandlers();
});

const datainfo = (id) => {
  handleKonwInfo(id);
};

const getKnowledgeSaleList = async () => {
  loading1.value = true;
  try {
    const res = await getBuyKnowledgeBaseList({
      pageIndex: 1,
      pageSize: 10,
    });
    if (res && Array.isArray(res.info.list)) {
      try {
        res.info.list.forEach((i, index) => {
          i.remark = index + 1;
        });
        knowledgeSaleList.value = res.info.list;
        loading1.value = false;
      } catch (innerError) {
        console.error("处理响应数据时出错:", innerError);
        loading1.value = true;
      }
    } else {
      console.error("响应数据格式不正确:", res);
      loading1.value = true;
    }
  } catch (requestError) {
    console.error("请求知识列表时出错:", requestError);
    loading1.value = true;
  }
};

const getKonwList = async () => {
  loading.value = true;
  try {
    const res = await PostknowLaDeist({
      isUp: "1",
      contentCid: infoList.value.contentCid,
    });
    if (res && Array.isArray(res.info)) {
      try {
        res.info.forEach((i, index) => {
          i.remark = index + 1;
        });
        knowLaDeist.value = res.info;
        loading.value = false;
      } catch (innerError) {
        console.error("处理响应数据时出错:", innerError);
        loading.value = true;
      }
    } else {
      console.error("响应数据格式不正确:", res);
      loading.value = true;
    }
  } catch (requestError) {
    console.error("请求知识列表时出错:", requestError);
    loading.value = true;
  }
};

const triggerParentEvent = async (event) => {
  const card = infoList.value;
  bus.emit("sendMsg", {
    card,
    event,
    lableBtn: lableBtnRef.value,
  });
};
const getImagePath = (filePath) => {
  const baseApi = process.env.VUE_APP_BASE_API;
  if (baseApi) {
    return process.env.VUE_APP_BASE_API + "/ckbop" + filePath;
  } else {
    return "/ckbop" + filePath;
  }
};

const redirectToWeb = async (data) => {
  router.push({
    name: "ifreamIndex",
    query: { id: data.id },
  });

  // console.log(weburl);
  // if (weburl) {
  //   window.open(weburl, "_blank");
  // } else {
  //   ElMessage.warning("暂无试用，请联系销售人员");
  // }
};
const handleKonwInfo = async (id) => {
  // 检查 id 是否有效
  if (!id) {
    return;
  }
  try {
    const res = await PostKonwInfo({ id: id });
    // 检查 res 是否存在且包含 info 属性
    if (res && res.info) {
      infoList.value = res.info;
      if (infoList.value.title) {
        document.title = "亿知知识库--" + infoList.value.title;
      }
      await getKonwList();
      const token = JSON.parse(Cookie.get("token")) || "";

      if (
        res.info.isIframe == "0" &&
        LoginType.value &&
        token &&
        !isTokenExpired(token)
      ) {
        await getResourcerecommend(res.info.id);
      }
    } else {
      console.error("响应数据格式不正确:", res);
    }
  } catch (error) {
    console.error("请求知识信息时出错:", error);
    // 可以在这里添加用户友好的提示，例如使用 UI 库的消息提示组件
    // 假设使用 ElementPlus 的 ElMessage
    if (typeof ElMessage === "function") {
      ElMessage.error("请求知识信息失败，请稍后重试");
    }
  }
};
const handleuserinfo = () => {
  userType.value = !userType.value;
};

const getResourcerecommend = async (id) => {
  try {
    const response = await getUnitUser({
      knowledgeId: id,
    });
    if (response.status == 200) {
      if (response.info.length > 0) {
        ciphertext.value = response.info[0].unitUserPassword || "";
        cipUsername.value = response.info[0].unitUserName || "";
      }
    } else {
      console.log("接口返回的数据为空或格式不正确");
    }
  } catch (error) {
    console.error("获取数据失败:", error);
  }
};
const decrypt = (ciphertext) => {
  try {
    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: CryptoJS.enc.Base64.parse(ciphertext) },
      ECB_KEY,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (e) {
    console.log("解密失败:", e);
    return null;
  }
};
// 统一的粘贴事件处理
const handlePasteEvent = async (event) => {
  console.log("统一粘贴事件");

  try {
    let clipboardText;
    // 尝试获取剪贴板内容
    try {
      clipboardText = await navigator.clipboard.readText();
    } catch (e) {
      // 如果权限被拒绝，尝试从event中获取
      clipboardText = event.clipboardData?.getData("text/plain");
    }

    if (!clipboardText) return;

    // 尝试解密剪贴板内容
    const decrypted = decrypt(clipboardText);
    if (!decrypted) return;

    // 阻止默认粘贴行为
    event.preventDefault();

    // 获取当前焦点元素
    const activeElement = document.activeElement;
    if (
      activeElement &&
      (activeElement.tagName === "INPUT" ||
        activeElement.tagName === "TEXTAREA")
    ) {
      // 在光标位置插入解密后的文本
      const start = activeElement.selectionStart;
      const end = activeElement.selectionEnd;
      activeElement.value =
        activeElement.value.substring(0, start) +
        decrypted +
        activeElement.value.substring(end);

      // 移动光标位置
      activeElement.selectionStart = activeElement.selectionEnd =
        start + decrypted.length;
    }
  } catch (error) {
    console.error("粘贴处理失败:", error);
  }
};
// 监听右键菜单粘贴事件
const handleContextMenu = (event) => {
  // 检查是否是粘贴操作（不同浏览器可能有不同的表现）
  if (event.target.tagName === "INPUT" || event.target.tagName === "TEXTAREA") {
    // 添加一个短暂延迟以确保剪贴板内容已更新
    setTimeout(() => {
      handlePasteEvent(event);
    }, 100);
  }
};

const copyUsername = async () => {
  if (!cipUsername.value) {
    ElMessage.warning("没有可复制的用户名");
    return;
  }

  try {
    // 确保用户名是字符串
    const username = String(cipUsername.value).trim();
    if (!username) {
      console.log("用户名为空");
    }
    if (navigator.clipboard?.writeText) {
      await navigator.clipboard.writeText(username);
    }
    // 回退方案
    else {
      const textarea = document.createElement("textarea");
      textarea.value = username;
      textarea.style.position = "fixed";
      textarea.style.opacity = "0";
      document.body.appendChild(textarea);
      textarea.select();

      try {
        if (!document.execCommand("copy")) {
          console.log("复制命令执行失败");
        }
      } finally {
        document.body.removeChild(textarea);
      }
    }

    ElMessage.success(`用户名已复制`);
  } catch (error) {
    console.error("复制用户名失败:", error);
    ElMessage.error(`复制失败: ${error.message}`);
  }
};

// 复制密码 - 自动加密
const copyPassword = async () => {
  if (!ciphertext.value) {
    ElMessage.warning("没有可复制的密码");
    return;
  }

  try {
    // 先解密再复制
    const decryptedPassword = decrypt(ciphertext.value);
    if (!decryptedPassword) {
      console.log("解密失败");
    }

    await copyToClipboard(decryptedPassword);
    ElMessage.success("密码复制");
  } catch (error) {
    console.error("复制失败:", error);
    ElMessage.error(`复制失败: ${error.message}`);
  }
};
// 通用的复制到剪贴板方法
const copyToClipboard = async (text) => {
  // 现代 Clipboard API
  if (navigator.clipboard && navigator.clipboard.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  // 备用方案：使用 document.execCommand
  const textarea = document.createElement("textarea");
  textarea.value = text;
  textarea.style.position = "fixed";
  textarea.style.opacity = "0";
  document.body.appendChild(textarea);
  textarea.select();

  try {
    if (!document.execCommand("copy")) {
      console.log("复制命令失败");
    }
  } finally {
    document.body.removeChild(textarea);
  }
};

// 设置全局粘贴事件监听
const setupPasteHandler = () => {
  document.addEventListener("paste", handlePaste);
};

// 全局粘贴处理 - 自动解密
// 修改原有的handlePaste函数
const handlePaste = (event) => {
  console.log("触发iframe中的粘贴事件");
  handlePasteEvent(event);
};

// 监听键盘Ctrl+V事件
const handleKeyDown = (event) => {
  // 检查是否是Ctrl+V或Cmd+V（Mac）
  if ((event.ctrlKey || event.metaKey) && event.key === "v") {
    handlePasteEvent(event);
  }
};
const hiddenTime = ref(Number);

window.addEventListener("load", async () => {
  // console.log('页面被刷新了',timestamp.value);
  const stored = localStorage.getItem("lastSelectTime");
  // console.log('当前时间戳：',Date.now());
  // const timestamp2 = ref(Number(sessionStorage.getItem('timestamp')))
  hiddenTime.value = Math.floor((Date.now() - stored) / 1000);
  try {
    const res = await getBuyLog({
      type: "3",
      url: weburl.value,
      second: hiddenTime.value,
    });
    if (res.status == 200) {
      // localStorage.removeItem("lastSelectTime");
      localStorage.setItem("lastSelectTime", Date.now().toString());
    }
  } catch (error) {
    console.log(error);
  }
});
// 设置事件监听器
const setupEventHandlers = () => {
  console.log("事件监听器");

  // 监听常规粘贴事件
  document.addEventListener("paste", handlePaste);
  // 监听右键菜单事件
  document.addEventListener("contextmenu", handleContextMenu);
  // 监听键盘事件
  document.addEventListener("keydown", handleKeyDown);
};

// 移除事件监听器
const removeEventHandlers = () => {
  document.removeEventListener("paste", handlePaste);
  document.removeEventListener("contextmenu", handleContextMenu);
  document.removeEventListener("keydown", handleKeyDown);
};

onUnmounted(() => {
  removeEventHandlers(); // 替换原来的removeEventListener
});
</script>

<style scoped>
/* 基础布局 */
.base-container {
  width: 100%;
  background: rgba(245, 245, 245, 1);
}

.content-wrapper {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px 0px;
}

.main-content {
  display: flex;
  gap: 20px;
  margin-bottom: 40px;
}

.left-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
  min-height: 866px;
}

.right-section {
  width: 346px;
  /* height: 472px; */
  min-height: 459px;
  background-color: #fff;
  /* background-image: url(@/assets/headerimage/rightback.png);
  background-repeat: no-repeat;
  background-position: top center; */
  overflow: hidden;
  display: flex;
  flex-direction: column;
  /* border-radius: 6px; */
  /* border-bottom-right-radius: 6px;
  border-bottom-left-radius: 6px; */
}
.right-section1 {
  margin-top: 30px;
}
/* 左侧内容样式 */
.main-info {
  background: #fff;
  padding: 20px;
  /* border-radius: 6px; */
  background-image: url(@/assets/headerimage/leftback.png);
  background-repeat: no-repeat;
  background-position: top center;
  background-size: cover;
}

.title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #333333;
  line-height: 28px;
  text-align: left;
  font-style: normal;
  margin-bottom: 20px;
}
.unit {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
}
.unit2 {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #999999;
  line-height: 20px;
  text-align: left;
  font-style: normal;
  margin-left: 20px;
}

.description {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  font-style: normal;
  text-align: justify;
  margin-bottom: 20px;
  margin-top: 16px;
}

.access-methods {
  display: flex;
  gap: 13px;
  margin: 20px 0;
}

.method1 {
  width: 280px;
  display: flex;
  align-items: center;
  /* border-right: 1px solid#EBEBEB; */
}
.method {
  width: 170px;
  display: flex;
  align-items: center;
}

.method-label {
  margin-left: 12px;
}

.action-buttons {
  display: flex;
  gap: 20px;
  margin-top: 30px;
}

.btn {
  width: 126px;
  height: 40px;
  background: #2c77ff;
  /* border-radius: 4px; */
  line-height: 40px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
  cursor: pointer;
}
.btn:hover {
  background: #2565d9;
}
.btn1:hover {
  background: linear-gradient(180deg, #ffb971 0%, #ff843e 100%);
}

.btn1 {
  width: 126px;
  height: 40px;
  background: #ff843e;
  /* border-radius: 4px; */
  line-height: 40px;
  text-align: center;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #ffffff;
  font-style: normal;
  cursor: pointer;
}

/* .btn:hover {
  background: rgba(31, 85, 222, 1);
  color: #fff; */
/* } */

/* 信息卡片样式 */
.info-cards {
  display: flex;
  gap: 19px;
}

.info-card {
  /* width: 480px; */
  width: 100%;
  background: #fff;
  padding: 20px;
}

.card-title {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #333333;
  line-height: 25px;
  text-align: left;
  font-style: normal;
  margin-bottom: 10px;
}

.card-content {
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  line-height: 20px;
  text-align: justify;
  font-style: normal;
  margin-bottom: 10px;
}

/* 右侧榜单样式 */
.ranking-div {
  height: 60px;
  border-top: 2px solid #1c6bfb;
}
.ranking-title {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-top: 17.5px;
  margin-left: 20px;
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-500;
  font-weight: 500;
  color: #1c6bfb;
}
.ranking-title1 {
  font-size: 18px;
  font-family: PingFang SC, PingFang SC-500;
  font-weight: 500;
  color: #333333;
}
.ranking-div1 {
  border-top: none;
  border-bottom: 1px solid #e4e7ed;
  padding-bottom: 17.5px;
}
.ranking-list {
  flex: 1;
  /* overflow-y: auto; */
  scrollbar-width: none;
  padding-bottom: 20px;
  padding-top: 16px;
  background: #ffffff;
}

.ranking-list::-webkit-scrollbar {
  display: none;
}

.ranking-item {
  display: flex;
  align-items: center;
  margin: 0px 20px;
  padding: 6px 0px;
  /* border-radius: 6px; */
  transition: background-color 0.2s;
  margin-top: 5px;
}

.ranking-item:hover,
.item-hover {
  /* background-color: #f2f9ff; */
  /* box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); */
  /* transform: translateY(-2px); */
  cursor: pointer;
}

.rank-badge {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  flex-shrink: 0;
  margin-right: 12px;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
}

/* 排名背景图片样式 */
.rank-1 {
  background-image: url(@/assets/headerimage/bd01.png);
}

.rank-2 {
  background-image: url(@/assets/headerimage/bd02.png);
}

.rank-3 {
  background-image: url(@/assets/headerimage/bd03.png);
}

.rank-4,
.rank-5,
.rank-6,
.rank-7,
.rank-8,
.rank-9,
.rank-10 {
  font-family: Arial, Arial;
  font-weight: normal;
  font-size: 14px;
  color: #999999;
  line-height: 16px;
  text-align: left;
  font-style: normal;
}

.rank1-1 {
  background-image: url(@/assets/headerimage/bang1.png);
}

.rank1-2 {
  background-image: url(@/assets/headerimage/bang2.png);
}

.rank1-3 {
  background-image: url(@/assets/headerimage/bang3.png);
}
/* 响应式设计 */
/* @media (max-width: 1200px) {
  .main-content {
    flex-direction: column;
  }

  .left-section,
  .right-section {
    width: 100%;
  }

  .info-cards {
    flex-direction: column;
  }

  .info-card {
    width: 100%;
  }

  .action-buttons {
    justify-content: center;
  }
} */

.el-carousel__item h3 {
  display: flex;
  color: #475669;
  opacity: 0.75;
  line-height: 300px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.info-banner {
  /* width: 979px; */
  height: 525.77px;
  width: 967px;
  padding-left: 67px;
  padding-top: 20px;
  opacity: 1;
  /* border: 0.2px solid rgba(76, 126, 253, 1); */
}
.el-carousel__item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.el-footer {
  --el-footer-padding: 0;
  --el-footer-height: 0;
  box-sizing: border-box;
  flex-shrink: 0;
  height: var(--el-footer-height);
  padding: var(--el-footer-padding);
}

.priceSpan {
  font-family: PingFangSC, PingFang SC;
  font-weight: 500;
  font-size: 18px;
  color: #333;
  line-height: 25px;
  text-align: left;
  font-style: normal;
}
.promotion {
  width: 100%;
  display: flex;
  justify-content: center;
  /* background: #1f55de; */
  /* padding-left: 43px; */
}
.promotionList {
  display: flex;
  justify-content: left;
  align-content: center;
  align-items: center;
  width: 1400px;
  height: 50px;
  /* line-height: 30px; */
}
.title_text {
  display: flex;
}
.rank-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-family: PingFangSC, PingFang SC;
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  line-height: 22px;
  text-align: left;
  font-style: normal;
  /* 确保元素有宽度（否则不会触发省略号） */
  width: 280px; /* 或固定宽度如 200px */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.rank-name:hover {
  color: #2c77ff;
}
::v-deep .el-breadcrumb__item:nth-child(-n + 2) .el-breadcrumb__inner.is-link,
::v-deep .el-breadcrumb__item:nth-child(-n + 1) .el-breadcrumb__separator {
  /* color: #fff; */
  /* font-weight: none; */
  text-decoration: none;
  transition: var(--el-transition-color);
}

::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner.is-link,
::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__separator {
  color: rgba(255, 255, 255, 0.65);
  /* font-weight: bold; */
  text-decoration: none;
  transition: var(--el-transition-color);
}
::v-deep .el-breadcrumb__inner.is-link {
  font-weight: none !important;
}
.baidu-iframe {
  width: 100%;
  flex-grow: 1;
  border: none;
  background: white;
  height: 70vh;
}

:deep(.el-card__body) {
  padding: 16px 15px 13px 16px;
}

.yhzximg {
  width: 62px;
  height: 59px; /* 增加高度以容纳文字 */
  position: fixed;
  right: 41px;
  bottom: 30px;
  z-index: 999;
  cursor: pointer;
  background: #ffffff;
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.12);
  border-radius: 6px;
  display: flex;
  flex-direction: column; /* 垂直排列图标和文字 */
  justify-content: center;
  align-items: center;
  padding: 10px; /* 上下内边距 */
  /* position: relative; */
}

.icon-container {
  margin-bottom: 0px; /* 图标和文字之间的间距 */
}

.yhzximg img {
  width: 24px;
  height: 24px;
  z-index: 999;
}

.text-container {
  font-size: 12px; /* 文字大小 */
  color: #333; /* 文字颜色 */
  text-align: center;
  white-space: nowrap; /* 防止文字换行 */
}

.getuserdraw {
  display: flex;
  flex-direction: column;
  /* gap: 16px;  */
  width: 140px; /* 容器宽度 */
  height: 90px;
  padding: 0px;
  border-radius: 8px;
  background-color: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  position: fixed;
  right: 130px;
  bottom: 30px;
}

.userlist {
  display: flex;
  align-items: center;
  margin: 10px 8px;
  gap: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.userlist2 {
  display: flex;
  align-items: center;
  margin: 6px 8px 10px 8px;
  gap: 4px;
  border-radius: 4px;
  transition: background-color 0.2s;
}
.userlist2:hover {
  background-color: #f5f7fa;
}

.userlist:hover {
  background-color: #f5f7fa;
}

.icon-wrapper {
  width: 24px;
  height: 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0; /* 防止图标被压缩 */
}

.icon-wrapper img {
  width: 14px;
  height: 14px;
  object-fit: contain;
}

.text-wrapper {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  /* padding: 7px 10px 7px; */
}
.text-wrapper2 {
  font-size: 14px;
  color: #333;
  white-space: nowrap;
  /* padding: 7px 10px 7px; */
}
.iframe-loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 255, 255, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1;
}

.loading-content {
  position: relative;
  text-align: center;
  padding: 30px;
  background: white;
  /* border-radius: 10px; */
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}
.closebut {
  position: absolute;
  top: 2px;
  right: 10px;
  color: #606266;
  cursor: pointer;
}

.loading-text {
  margin-top: 20px;
  font-size: 16px;
  color: #606266;
}

.baidu-iframe {
  width: 100%;
  flex-grow: 1;
  border: none;
  background: white;
  height: 70vh;
  position: relative;
  z-index: 0;
}

.content_div {
  width: 1034px;
  /* height: 518px; */
  background: #ffffff;
  padding: 20px;
}
.content_title {
  font-size: 20px;
  font-family: PingFang SC, PingFang SC-500;
  font-weight: 500;
  text-align: CENTER;
  color: #333333;
}
.content_fx {
  padding: 20px 0px;
  display: flex;
  justify-content: right;
  font-size: 12px;
  font-weight: 400;
  color: #999999;
  position: relative;
}
.content_fx_icon {
  display: flex;
  gap: 8px;
  align-items: center;
}
.content_fx_icon img {
  width: 14px;
  height: 15px;
  cursor: pointer;
}

.content_row {
  float: none;
  min-height: 26px;
  padding-top: 8px;
  font-size: 14px;
  color: #000;
  clear: both;
  text-align: justify;
  text-justify: inter-word;
  display: table;
  width: 100%;
}
.content_row_tit {
  display: table-cell;
  vertical-align: top;
  padding-right: 5px;
  line-height: 26px;
  font-weight: bold;
  white-space: nowrap;
  width: 8px;
}
.content_row .content_row_tit {
  margin: 0 10px 2px 0;
}

.content_row_right {
  line-height: 26px;
  text-justify: inter-word;
  color: #666;
  word-wrap: break-word;
  display: table-cell;
}

.tab_div {
  height: 40px;
  width: 100%;
  border-bottom: 1px solid #e4e7ed;
  background-color: #ffffff;
  display: flex;
}
.tab_content_div {
  width: 100%;
  background-color: #ffffff;
}
.tab_div_div {
  width: 96px;
  cursor: pointer;
}
.tab_div_div:hover {
  color: #1c6bfb;
}
.tab_div_div2 {
  width: 98px;
  border-left: 1px solid #e4e7ed;
  border-right: 1px solid #e4e7ed;
}
.tab_div_div p {
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-400;
  font-weight: 400;
  text-align: LEFT;
  color: #333333;
  padding: 10px 20px;
}
.tabActive {
  border-top: 2px solid #1c6bfb;
  color: #1c6bfb;
}
.tabActive p {
  padding-top: 8px;
}
.feature_div {
  font-size: 14px !important;
  color: #333 !important;
  line-height: 30px;
}
::v-deep .feature_div ol {
  list-style: disc;
  padding-left: 40px;
}
::v-deep .feature_div ul {
  list-style: circle;
  padding-left: 40px;
}
.attach_ul {
  list-style: none;
  padding-left: 20px;
}
.attach_ul li {
  display: flex;
  justify-content: space-between;
}
.attach_ul li p {
  font-size: 14px;
  color: #333333;
  line-height: 32px;
}

.attach_down {
  cursor: pointer;
}
.attach_down:hover {
  color: #1c6bfb;
}
::v-deep .el-carousel__indicators--outside {
  text-align: center;
}
/* .attach_ul li p:first-child{
  float: left;
}
.attach_ul li p:last-child{
  float: right;
} */
.right_img {
  width: 100px;
  height: 60px;
  display: none;
}
.right_fangshi {
  display: none;
}
.ranking-item:hover {
  .right_img {
    display: block;
  }
  .right_fangshi {
    display: block;
  }
  .right_content_title {
    margin-left: 8px;
  }
  .rank-name {
    width: 150px;
  }
}
.qr-code-modal {
  width: 240px;
  height: 272px;
  position: absolute;
  /* position: fixed; */
  top: 43px;
  /* left: 0; */
  right: -20px;
  bottom: 0;
  /* background-color: rgba(0, 0, 0, 0.5); */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}
.qr-code-container {
  background: white;
  padding: 20px;
  /* border-radius: 8px; */
  text-align: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
}

.qr-code-title {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 10px;
}

.qr-code-image {
  width: 200px;
  height: 200px;
  margin: 0 auto;
}

.qr-code-tip {
  margin-top: 10px;
  color: #666;
  font-size: 14px;
}

.qr_draw {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  /* background: rgba(0, 0, 0, 0.5); */
}
</style>
